export class OfficeEditModel{
    officeId:string;
    officeTypeId:number;
    officeLevel:string;
    nameBn:string;
    nameEn:string;
    address:string;
    parentOfficeId:number;
    parentOfficeName:string;
}